import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertSaleReceipt = createAsyncThunk('insertSaleReceipt', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertSaleReceiptEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});




// export const fetchTrimmingEmplist = createAsyncThunk('fetchTrimmingEmplist', async (id) => {
//     try {
//         const endpoint = id ? `getTrimmingEmployee&empId=${id}` : 'getTrimmingEmployee';
//         const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });


const receiptApiSlice = createSlice({
    name: 'ReceiptDatalist',
    initialState: {
        isLoading: false,
       
        isError: false
    },
    extraReducers: (builder) => {
        // builder.addCase(fetchKajeInwMemo.pending, (state, action) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(fetchKajeInwMemo.fulfilled, (state, action) => {
        //     state.isLoading = false;
        //     state.kjInwMemo = action.payload;
        // });
        // builder.addCase(fetchKajeInwMemo.rejected, (state, action) => {
        //     console.log('Error', action.error.message);
        //     state.isError = true;
        // });

        

       

    }
});

export default receiptApiSlice.reducer;
